import { Directive } from "@app/components/directive";
import * as angular from "angular";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * Creates a new scope for ng-include along with being able to set variables on the new scope
 */
@NgComponent({
    token: Token.KbInclude,
    dependencies: [
        Token.$TemplateRequest,
        Token.$Compile
    ]
})
export class KbInclude extends Directive {
    constructor(
        $templateRequest: ng.ITemplateRequestService,
        $compile: ng.ICompileService
    ) {
        super();

        this.restrict = "A";
        this.link = (scope, element: JQuery, atts: any) => {
            let templateUrl = scope.$eval(atts.kbInclude);

            $templateRequest(templateUrl, true).then(response => {
                let $template = angular.element(response);
                // compile the template
                let compiled = $compile($template);
                // append it to the label
                element.replaceWith($template);
                // now link it to the parent scope(we don't want this scope because it's an isolate scope)
                compiled(scope);
            });
        };
    }
}
